// extracted by mini-css-extract-plugin
module.exports = {"summaryTable":"checkout_summaryTable__2bxi1","total":"checkout_total__1Evo1"};